'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024 from "./presto.types$-Two-Factor-Auth-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$Tables$$anon$11() {
}
export { $c_Lpresto_TwoFactorAuthView$Tables$$anon$11 as $c_Lpresto_TwoFactorAuthView$Tables$$anon$11 };
$p = $c_Lpresto_TwoFactorAuthView$Tables$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$Tables$$anon$11;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$Tables$$anon$11() {
}
export { $h_Lpresto_TwoFactorAuthView$Tables$$anon$11 as $h_Lpresto_TwoFactorAuthView$Tables$$anon$11 };
$h_Lpresto_TwoFactorAuthView$Tables$$anon$11.prototype = $p;
$p.b6 = (function(_$5) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$5, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$6) => _$6.e1.kZ)), $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024.$m_Lpresto_types$TwoFactorAuthName$().crL());
});
var $d_Lpresto_TwoFactorAuthView$Tables$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$Tables$$anon$11, "presto.TwoFactorAuthView$Tables$$anon$11", ({
  Ub: 1,
  G: 1
}));
export { $d_Lpresto_TwoFactorAuthView$Tables$$anon$11 as $d_Lpresto_TwoFactorAuthView$Tables$$anon$11 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Tables$$anon$11.js.map
